//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// dto_for_DV1_AddTranslation_Request
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export class dto_for_DV1_AddTranslation_Request {

    language_id = null
    entity_name = ""
    entity_id = null
    attribute_name = ""
    attribute_value = ""
    publish = null

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    //constructor(){
    //};
}